import React from "react";
import { TableContainer, Table, TableRow, TableHead, TableCell, TableBody } from "@mui/material";

export default function CustDebt() {
  return (
    <div>
      <div style={{ margin: "0 auto", width: 794 }}>
        <div style={{ marginBottom: 30 }}>{/* filter */}</div>
        <div>
          <div>
            <h2>Some title</h2>
          </div>
          <div align="left">Customer ID:</div>
          <div align="left">Customer Name:</div>
        </div>
        {/* Summary */}
        <div>
          <div align="left" style={{ color: "#549fff", margin: "20px 0", fontSize: 22 }}>
            I. Summary
          </div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" colSpan={4}>
                    ORIGINAL CURRENCY
                  </TableCell>
                  <TableCell align="" colSpan={2}>
                    VND
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="" colSpan={2}></TableCell>
                  <TableCell align="right" colSpan={1}>
                    Nợ
                  </TableCell>
                  <TableCell align="" colSpan={1}>
                    Có
                  </TableCell>
                  <TableCell align="right" colSpan={1}>
                    Nợ
                  </TableCell>
                  <TableCell align="" colSpan={1}>
                    Có
                  </TableCell>
                </TableRow>
                <TableRow style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                  <TableCell align="">1</TableCell>
                  <TableCell align="">OPENING BALANCE</TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="">1</TableCell>
                  <TableCell align="">VND</TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                </TableRow>
                <TableRow style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                  <TableCell align="">2</TableCell>
                  <TableCell align="">INCURRED</TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="">1</TableCell>
                  <TableCell align="">VND</TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                </TableRow>
                <TableRow style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                  <TableCell align="">3</TableCell>
                  <TableCell align="">CLOSING BALANCE</TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="">1</TableCell>
                  <TableCell align="">VND</TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                  <TableCell align=""></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div>
          <div align="left" style={{ color: "#549fff", margin: "20px 0", fontSize: 22 }}>
            II. Details
          </div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox" align="center" rowSpan={2}></TableCell>
                  <TableCell padding="checkbox" align="center" colSpan={2}>
                    TRANSACTION
                  </TableCell>
                  <TableCell padding="checkbox" align="center" rowSpan={2}>
                    CONTENT
                  </TableCell>
                  <TableCell padding="checkbox" align="center" rowSpan={2}>
                    REMARKS
                  </TableCell>
                  <TableCell padding="checkbox" align="center" rowSpan={2}>
                    CURRENCY
                  </TableCell>
                  <TableCell padding="checkbox" align="center" colSpan={2}>
                    ORIGINAL CURR
                  </TableCell>
                  <TableCell padding="checkbox" align="center" colSpan={2}>
                    VND
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell padding="checkbox" align="center">
                    No.
                  </TableCell>
                  <TableCell padding="checkbox" align="center">
                    Time
                  </TableCell>
                  <TableCell padding="checkbox" align="center">
                    Nợ
                  </TableCell>
                  <TableCell padding="checkbox" align="center">
                    Có
                  </TableCell>
                  <TableCell padding="checkbox" align="center">
                    Nợ
                  </TableCell>
                  <TableCell padding="checkbox" align="center">
                    Có
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* viet lai khi co api */}
                <TableRow>
                  <TableCell padding="checkbox">1</TableCell>
                  <TableCell padding="checkbox">MONTH 9</TableCell>
                  <TableCell padding="checkbox">30/9/2021 8:59</TableCell>
                  <TableCell padding="checkbox">Noi dia - xe bon</TableCell>
                  <TableCell padding="checkbox"></TableCell>
                  <TableCell padding="checkbox">VND</TableCell>
                  <TableCell padding="checkbox" align="right">
                    1000
                  </TableCell>
                  <TableCell padding="checkbox"></TableCell>
                  <TableCell padding="checkbox" align="right">
                    1000
                  </TableCell>
                  <TableCell padding="checkbox"></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}
